import React from "react";
import { Container, OverviewCard } from "../../components";
import { useStakingContext } from "../../context/staking-context";

export default function OverviewSection() {
  const { overview, isFetchingOverview, overviewTooltipDetail} = useStakingContext();

  return (
    <section className="relative flex">
      <Container className="!px-0">
        <h2 className="text-[24px] leading-6 md:text-[30px] md:leading-[30px] font-medium -tracking-16 text-textcolor">
          Overview
        </h2>

        <div className="mt-3 laptop:mt-[25px] grid gap-[9px] grid-cols-2 sm:grid-cols-3 laptop:grid-cols-4">
          {Object.entries(overview).map(([key, value]) => (
            <div key={key} className="col-span-1">
              <OverviewCard
                title={key}
                value={value}
                isFetching={isFetchingOverview}
                info={true}
                overviewTooltipDetail={overviewTooltipDetail}
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
